<template>
  <header
    class="bg-white border-b border-slate-200 shadow-[0_1px_3px_rgba(0,0,0,0.06)]"
    style="font-family: 'Plus Jakarta Sans', Inter, sans-serif;"
  >
    <div class="tw-flex justify-between items-center w-full max-w-[1440px] mx-auto px-6 lg:px-12 h-16">

      <!-- Left: logo + nav -->
      <div class="tw-flex items-center gap-8">
        <span
          class="text-[1.2rem] font-extrabold text-[#071c5b] tracking-[-0.02em] whitespace-nowrap cursor-pointer hover:opacity-[0.85] transition-opacity"
          @click="$router.push('/dashboards/home')"
        >
          Zorg &amp; Welzijn
        </span>
        <nav class="hidden md:tw-flex items-center gap-6">
          <span
            v-for="item in navItems"
            :key="item.key"
            class="text-[0.9rem] pb-1 border-b-2 cursor-pointer transition-[color,border-color] duration-150"
            :class="currentPage === item.key
              ? 'text-[#071c5b] font-bold border-[#071c5b]'
              : 'font-medium text-slate-500 border-transparent hover:text-[#071c5b]'"
            @click="$router.push(item.path)"
          >{{ item.label }}</span>
        </nav>
      </div>

      <!-- Right: hamburger (mobile only) + other actions -->
      <div class="tw-flex items-center gap-2">
        <!--        <button
                class="p-2 rounded-lg bg-transparent border-none cursor-pointer tw-flex items-center hover:bg-slate-100 active:scale-95 transition-all"
                title="Zoeken"
                @click="openSearch"
              >
                <span class="material-symbols-outlined text-[#071c5b]">search</span>
              </button>
                <button
                  class="p-2 rounded-lg bg-transparent border-none cursor-pointer tw-flex items-center hover:bg-slate-100 active:scale-95 transition-all"
                  title="Geef feedback"
                  @click="openFeedbackWindow"
                >
                  <Icon name="information-outline" fill="#071c5b"/>
                </button>
                <div
                  class="w-8 h-8 rounded-full overflow-hidden border-2 border-[#dde1ff] ml-2 bg-[#dde1ff] tw-flex items-center justify-center flex-shrink-0 cursor-pointer"
                  @click="$router.push('/profile')"
                >
                  <img v-if="userAvatar" :src="userAvatar" alt="Profiel" class="w-full h-full object-cover"/>
                  <span v-else class="material-symbols-outlined" style="font-size: 18px; color: #324381;">person</span>
                </div>-->

        <!-- Hamburger — mobile only -->
        <button
          class="md:hidden p-2 rounded-lg bg-transparent border-none cursor-pointer tw-flex items-center justify-center hover:bg-slate-100 transition-colors"
          @click="mobileMenuOpen = !mobileMenuOpen"
        >
          <span class="material-symbols-outlined text-[#071c5b]">{{ mobileMenuOpen ? 'close' : 'menu' }}</span>
        </button>
      </div>

    </div>

    <!-- Mobile nav dropdown -->
    <div
      v-if="mobileMenuOpen"
      class="md:hidden border-t border-slate-100 bg-white px-6 py-3 tw-flex flex-col gap-1"
    >
      <span
        v-for="item in navItems"
        :key="item.key"
        class="text-[0.95rem] py-3 px-2 rounded-lg cursor-pointer transition-colors duration-150 font-medium"
        :class="currentPage === item.key
          ? 'text-[#071c5b] font-bold bg-[#f0f2ff]'
          : 'text-slate-600 hover:text-[#071c5b] hover:bg-slate-50'"
        @click="navigate(item.path)"
      >{{ item.label }}</span>
    </div>
  </header>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Icon/Icon.vue'
  import { MUTATION_TYPES as UI_MUTATION_TYPES } from '@/store/modules/ui.js'

  export default defineComponent({
    name: 'TopBarStaticSamergo',
    components: { Icon },
    data() {
      return {
        mobileMenuOpen: false,
      }
    },
    computed: {
      navItems() {
        return [
          { key: 'home', label: 'Dashboard', path: '/dashboards/home' },
          { key: 'actors', label: 'Zorgverleners', path: '/actors-simplified' },
          { key: 'network', label: 'Netwerk', path: '/my-network' },
          { key: 'instellingen', label: 'Instellingen', path: '/actors-simplified' },
        ]
      },
      currentPage() {
        const path = this.$route.path
        if (path.startsWith('/actors')) return 'actors'
        if (path.startsWith('/my-network')) return 'network'
        return 'home'
      },
      userAvatar() {
        return this.$store.state.user?.profile?.image || null
      },
    },
    methods: {
      navigate(path: string) {
        this.mobileMenuOpen = false
        this.$router.push(path)
      },
      openSearch() {
        this.$store.commit(UI_MUTATION_TYPES.SHOW_GLOBAL_SEARCH)
      },
      openFeedbackWindow() {
        (document.querySelector('.userback-button-e') as HTMLElement)?.click()
      },
    },
  })
</script>
